import mutatorClassOrder from '@/lib/mutator-class-order.json'
import { type Stageable } from '@/lib/entity/base'

/**
 * Sorts an array of stageable entities based on a predefined order of class names.
 * Entities are sorted according to the order defined in the `mutatorClassOrder` array.
 * Unknown or unlisted class names are placed at the end of the sorted array.
 *
 * @function
 * @param {Stageable[]} entities - An array of stageable entities to be sorted.
 * @returns {Stageable[]} A new array of entities sorted by the predefined class order.
 */
export const sortEntities = (entities: Stageable[]) => {
  const orderIndex: Record<string, number> = Object.create(null)
  for (let i = 0; i < (mutatorClassOrder as string[]).length; i++) {
    orderIndex[(mutatorClassOrder as string[])[i]] = i
  }

  return entities.sort((a, b) => {
    const aName = a.className
    const bName = b.className

    // TODO: 暫定対応。削除時の逆順ソートが廃止されたため、外部キー制約を考慮した個別対応。
    //       将来的には依存関係を定義した汎用的な仕組みに再設計する。
    //       https://github.com/iridgeinc/co-assign-front/issues/1234
    // 削除時: TargetCostOtherActualMutator（子）を TargetCostOtherMutator（親）より先に削除
    if (a.isDeleted && b.isDeleted) {
      if (aName === 'TargetCostOtherActualMutator' && bName === 'TargetCostOtherMutator') {
        return -1
      }
      if (aName === 'TargetCostOtherMutator' && bName === 'TargetCostOtherActualMutator') {
        return 1
      }
    }

    const aIdx = orderIndex[aName]
    const bIdx = orderIndex[bName]
    // 未知クラスは末尾に配置
    const aRank = aIdx !== undefined ? aIdx : Number.MAX_SAFE_INTEGER
    const bRank = bIdx !== undefined ? bIdx : Number.MAX_SAFE_INTEGER

    if (aRank !== bRank) return aRank - bRank

    // Stable for equal ranks (including both unknowns)
    return 0
  })
}
